import { Row } from 'farmhub-ui-core';
import styled from 'styled-components';

export const WrapperFilter = styled.div<{
  width: string;
  isDisplayFilter: boolean;
  padding?: string;
  borderBottom?: boolean;
  background: string;
}>`
  justify-content: space-between;
  display: ${p => (p.isDisplayFilter ? 'flex' : 'none')};
  width: ${p => p.width};
  height: auto;
  background: ${props => props.background};
  align-items: center;
  border-bottom: ${p =>
    p.borderBottom ? `1px solid ${p.theme.colors.border.light}` : ''};
  padding: ${p => p.padding || `${p.theme.app.padding.vertical} 0px`};

  .ant-select-selection-overflow-item.ant-select-selection-overflow-item-rest {
    .ant-select-selection-item {
      height: 23px;
    }
  }
`;

export const WrapperTagsFilter = styled.div<{ borderBottom?: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px 0px 18px 0px;
  border-bottom: ${p =>
    p.borderBottom ? `1px solid p.theme.colors.border.light` : ''};
`;

export const WrapperStatus = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  position: relative;
  > div {
    padding-right: 23px;
  }
`;

export const WrapperIcon = styled.span`
  position: absolute;
  right: 5px;
  font-size: ${props => props.theme.font.size.tiny};
  color: #575757;
  &:hover {
    cursor: pointer;
  }
`;

export const PopupRow = styled(Row)`
  height: ${p => p.theme.select.height.lg};
  padding: ${p => p.theme.app.padding.horizontal};
`;

export const FilterWrapperMobile = styled(Row)`
  .ant-input-affix-wrapper {
    border-radius: 0px 6px 6px 0px !important;
    margin-left: -1px !important;
  }
`;

export const WrapperMobile = styled.div<{ active: boolean }>`
  width: 100%;
  padding: ${p => p.theme.app.padding.vertical}
    ${p => p.theme.app.padding.horizontal} !important;
  position: relative;

  cursor: pointer;

  transition: all 0.4s;

  &:hover {
    &::before {
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: ${props => props.theme.radius.md};
      background: ${props => props.theme.colors.primary.main} !important;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  svg {
    path {
      fill: ${props => props.theme.colors.primary.main};
    }
  }

  ${props =>
    props.active
      ? `&::before {
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: ${props.theme.radius.md};
      background: ${props.theme.colors.primary.main} !important;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 0;
    }`
      : ''}
`;
